// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';

// Section for type definition -----------------------------------------------------------------------------------------
import MansionReviewPropsData from '@/types/components/MansionDetail/MansionReviewPropsData';

const initialMansionReview: MansionReviewPropsData = false;

export const MansionReviewContext: React.Context<MansionReviewPropsData> =
  createContext<MansionReviewPropsData>(initialMansionReview);

export const UpdateMansionReview: React.Context<any> = createContext(initialMansionReview);
// export const SelectedCitiesConsumer = SelectedCitiesContext.Consumer;
export const useMansionReview = () => useContext(MansionReviewContext);
export const useUpdateMansionReview = () => useContext(UpdateMansionReview);

// Section for render component ----------------------------------------------------------------------------------------
function MansionReviewProvider(props: any): React.JSX.Element {
  const { children, mansionReview } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [stateMansionReview, setMansionReview] = useState(mansionReview);
  // valueにグローバルに扱う値を設定
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <MansionReviewContext.Provider value={mansionReview}>
      <UpdateMansionReview.Provider value={setMansionReview}>{children}</UpdateMansionReview.Provider>
    </MansionReviewContext.Provider>
  );
}

export default MansionReviewProvider;
